"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductType = void 0;
var ProductType;
(function (ProductType) {
    ProductType["BoxProduct"] = "box";
    ProductType["ExperienceProduct"] = "experience";
    ProductType["ValueVoucherProduct"] = "value_voucher";
})(ProductType = exports.ProductType || (exports.ProductType = {}));
//# sourceMappingURL=productType.js.map